import { render, staticRenderFns } from "./ShowAliases.vue?vue&type=template&id=0b28d822"
import script from "./ShowAliases.vue?vue&type=script&lang=js"
export * from "./ShowAliases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports